module.exports = __webpack_public_path__ + "img/blue_008.cc5308c9.png";